<div class="flex flex-col gap-3">
  <label class="flex flex-col gap-1">
    <span class="text-sm font-medium">Nombre</span>
    <input [formField]="formRecurso.nombre" type="text" class="w-full" />
  </label>
  <label class="flex flex-col gap-1">
    <span class="text-sm font-medium">Descripción</span>
    <textarea [formField]="formRecurso.descripcion" class="w-full" rows="2"></textarea>
  </label>
  <div class="grid grid-cols-2 gap-3">
    <label class="flex flex-col gap-1">
      <span class="text-sm font-medium">Duración (minutos)</span>
      <input [formField]="formRecurso.duracion_minutos" type="number" class="w-full" />
    </label>
    <label class="flex flex-col gap-1">
      <span class="text-sm font-medium">Capacidad</span>
      <input [formField]="formRecurso.capacidad" type="number" class="w-full" />
    </label>
  </div>
  <label class="flex flex-col gap-1">
    <span class="text-sm font-medium">Precio base (S/)</span>
    <input [formField]="formRecurso.precio" type="number" class="w-full" />
  </label>
  <div class="flex justify-end gap-2 pt-2">
    <app-button label="Cancelar" variant="secondary" (onClick)="onCerrar()" />
    <app-button label="Guardar cambios" (onClick)="guardar()" [disabled]="formRecurso().invalid()" />
  </div>
</div>